import { fetchEventSource } from '@microsoft/fetch-event-source';
import axios from 'axios';
import { auth } from '../../../firebase';
import {
  NotificationsResponse,
  NotificationType,
} from '../../Interfaces/system/Notifications.interfaces';

const apiUrl = process.env['NX_API_URL'];

export const fetchNotifications = async (
  cursor?: Date,
  limit?: number,
  companyId?: string,
  types?: NotificationType[],
  process?: string,
  job?: string
): Promise<NotificationsResponse> => {
  const response = await axios.get(`${apiUrl}/api/notifications`, {
    params: { cursor, limit, companyId, types, process, job },
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${await auth.currentUser?.getIdToken()}`,
    },
  });
  return response.data;
};

export const fetchUnreadCount = async (): Promise<number> => {
  const response = await axios.get(`${apiUrl}/api/notifications/unread_count`, {
    headers: {
      Authorization: `Bearer ${await auth.currentUser?.getIdToken()}`,
    },
  });
  return response.data;
};

export const markNotificationRead = async (id: string): Promise<void> => {
  await axios.put(`${apiUrl}/api/notifications/${id}/read`, null, {
    headers: {
      Authorization: `Bearer ${await auth.currentUser?.getIdToken()}`,
    },
  });
};

export const markAllNotificationsRead = async (): Promise<void> => {
  await axios.put(`${apiUrl}/api/notifications/read_all`, null, {
    headers: {
      Authorization: `Bearer ${await auth.currentUser?.getIdToken()}`,
    },
  });
};

export const openNotificationsStream = (
  onMessage: (data: unknown) => void,
  onError?: () => void
): AbortController => {
  const controller = new AbortController();

  fetchEventSource(`${apiUrl}/api/notifications/stream`, {
    signal: controller.signal,
    openWhenHidden: true,
    async fetch(input, init) {
      const token = await auth.currentUser?.getIdToken();
      return window.fetch(input, {
        ...init,
        headers: { ...init?.headers, Authorization: `Bearer ${token}` },
      });
    },
    onmessage(event) {
      try {
        onMessage(JSON.parse(event.data));
      } catch {
        // ignore malformed events
      }
    },
    onerror(err) {
      if (controller.signal.aborted) throw err;
      onError?.();
    },
  });

  return controller;
};
